import { EMPTY_ARRAY, type UseFilterBuilderProps, type UsePersistedBlotterTable } from '@talos/kyoko';
import { useCallback, useMemo, useState } from 'react';
import type { LocalAgGridFilter } from './useDateAndQuickTextFilter';

interface UseMarginFilterParams {
  persistedBlotterTable: Pick<UsePersistedBlotterTable, 'initialState'>;
  showZeroBalances: boolean;
}

export function useMarginFilter({ persistedBlotterTable, showZeroBalances }: UseMarginFilterParams) {
  const [initialFilter] = useState(() => persistedBlotterTable.initialState?.filter ?? {});

  const clientSideFilter = useCallback<LocalAgGridFilter>(
    row => showZeroBalances || row.data.Amount !== '0',
    [showZeroBalances]
  );

  const filterBuilderProps = useMemo(
    () => ({
      initialFilterClauses: EMPTY_ARRAY,
      properties: EMPTY_ARRAY,
    }),
    []
  ) satisfies UseFilterBuilderProps;

  return useMemo(
    () => ({
      initialFilter,
      clientSideFilter,
      filterBuilderProps,
    }),
    [clientSideFilter, filterBuilderProps, initialFilter]
  );
}
